import { useFormContext } from 'react-hook-form';

import { useErrorToast } from './useErrorToast';

export const useValidationErrorToast = () => {
  const {
    formState: { submitCount, isValid },
  } = useFormContext();
  useErrorToast(submitCount > 0 && !isValid);
};
